// Sort orders shared by the map and client overviews.
//
// Sorting is the server's job — a list is paged, so ordering the items that
// happen to be loaded would only order part of it. What lives here is the
// vocabulary both ends agree on: these values are sent as ``?sort=``.
export const OVERVIEW_SORT = {
    NAME_ASC: 'name-asc',
    NAME_DESC: 'name-desc',
    CREATED_DESC: 'created-desc',
    CREATED_ASC: 'created-asc',
    MODIFIED_DESC: 'modified-desc',
    MODIFIED_ASC: 'modified-asc',
    ID_ASC: 'id-asc',
    ID_DESC: 'id-desc',
};

// Order the options appear in the dropdown, with their translation keys.
const SORT_LABEL_KEYS = [
    [OVERVIEW_SORT.NAME_ASC, 'overviewSort.nameAsc'],
    [OVERVIEW_SORT.NAME_DESC, 'overviewSort.nameDesc'],
    [OVERVIEW_SORT.CREATED_DESC, 'overviewSort.createdDesc'],
    [OVERVIEW_SORT.CREATED_ASC, 'overviewSort.createdAsc'],
    [OVERVIEW_SORT.MODIFIED_DESC, 'overviewSort.modifiedDesc'],
    [OVERVIEW_SORT.MODIFIED_ASC, 'overviewSort.modifiedAsc'],
    [OVERVIEW_SORT.ID_ASC, 'overviewSort.idAsc'],
    [OVERVIEW_SORT.ID_DESC, 'overviewSort.idDesc'],
];

// What an overview offers unless it asks for something else. The identifier
// orders are not among them: they say nothing to someone looking at maps or
// clients, and are only meaningful where the id is on screen.
const DEFAULT_SORT_ORDERS = SORT_LABEL_KEYS
    .filter(([value]) => value !== OVERVIEW_SORT.ID_ASC && value !== OVERVIEW_SORT.ID_DESC)
    .map(([value]) => value);

/**
 * Build the localized option list for the sort dropdown.
 *
 * :param t: vue-i18n translate function.
 * :param values: the orders to offer, defaulting to the usual ones.
 * :returns: array of ``{value, label}`` objects.
 */
export function buildSortOptions(t, values = DEFAULT_SORT_ORDERS) {
    const labels = new Map(SORT_LABEL_KEYS);
    return values
        .filter(value => labels.has(value))
        .map(value => ({value, label: t(labels.get(value))}));
}
